import * as React from "react";

function SvgArrowIcon(props) {
  return <svg xmlns="http://www.w3.org/2000/svg" fill="none" width="1em" height="1em" viewBox="0 0 9.995 5.891" {...props}><rect x={10.495} y={7.297} width={0.282} height={6.049} rx={0.141} stroke="currentColor" transform="rotate(135 10.37 5.89)" /><rect x={19.583} y={6.391} width={0.282} height={6.049} rx={0.141} stroke="currentColor" transform="rotate(-135 9.995 9.655)" /></svg>;
}

export default SvgArrowIcon;